import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useEffect, useState } from 'react'
import { printPrice } from '../../utils/functions';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimes,    
    faPhone,
    faMapMarkerAlt,
    faEnvelope,
    faClock,
    faHeart,
    faMugHot,
    faShoppingBag,
    faTrashAlt,
    faPlusCircle,
    faPlusMinus,
    faMinusCircle,  
} from "@fortawesome/free-solid-svg-icons";
import ModalProduct from '../../components/products/ModalProduct';
import ModalCheckoutForm from '../../components/common/ModalCheckoutForm';
import { PRODUCTS } from '../products/productsInfoShop'; 
import banner from '../../assets/images/photos/banner.jpg'
import image1 from '../../assets/images/photos/image-gallery2.jpg'
import image2 from '../../assets/images/photos/image-1.jpg'
import image3 from '../../assets/images/photos/image-2.jpg' 
import image4 from '../../assets/images/photos/image-3.jpg'
import image5 from '../../assets/images/photos/image-gallery1.jpg'
import image6 from '../../assets/images/photos/image-5.jpg'     
import avartar from "../../assets/images/avatar.jpg"
import { CardProduct } from '../../components/common/CardProduct';
import { Formik } from 'formik';
import { Form } from 'react-router-dom';
import MyTextInput from '../../components/common/MyTextInput';

interface ProductCartInterface {
  name: string;
  price: number;
  quantity: number;
  images?: string;
    id: number;
    description: string;
}



interface PersonalInfoInterface {
  name: string;
  description: string;
  address: string;
}

export default function BusinessShopPage() {

  const [cartShopping, setCartShopping] = useState<
        Array<ProductCartInterface>
    >([]);
   
  const [showModalCheckoutForm, setShowModalCheckoutForm] =
  useState<boolean>(false);
const [open, setOpen] = useState<boolean>(false);
  const [subTotal, setSubTotal] = useState<number>(0);
  const [seletedProduct, setSeletedProduct] =
    useState<ProductCartInterface | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
  

  useEffect(() => {
    (async () => {
        let subTotalTemp: number = 0;
        for await (const product of cartShopping) {       
                subTotalTemp += product?.price * product.quantity;           
        }
        setSubTotal(subTotalTemp);
    })();
  }, [cartShopping]);
  

  const addCart = (value: ProductCartInterface) => {
    let productTemp = cartShopping.find(item => item.id === value.id);

    if (!productTemp) {
        let newProductTemp: ProductCartInterface;
        newProductTemp = {
            name: value.name,
            price: value.price,
            quantity: 1,
            images: value.images,
            id: value.id,
            description: value.description
        };
        const cartShoppingTemp = [...cartShopping, newProductTemp];
        setCartShopping(cartShoppingTemp);
    } else {
        const cartShoppingTemp = cartShopping.map(item => {
            if (item.id === productTemp?.id) {
                return {
                    ...item,
                    quantity: productTemp.quantity + 1,
                };
            } else {
                return item;
            }
        });
        setCartShopping(cartShoppingTemp);
    }
    setOpen(true);
  }; 
  const removeQuantityCart = (value: ProductCartInterface) => {
    let productTemp = value;
    const cartShoppingTemp = cartShopping.map(item => {
        if (item.id === productTemp?.id) {
            return {
                ...item,
                quantity: productTemp.quantity - 1,
            };
        } else {
            return item;
        }
    });
    setCartShopping(cartShoppingTemp);
  };
  const addProductCart = (value: ProductCartInterface) => {
    let productTemp = value;
    const cartShoppingTemp = cartShopping.map(item => {
        if (item.id === productTemp?.id) {
            return {
                ...item,
                quantity: productTemp.quantity + 1,
            };
        } else {
            return item;
        }
    });
    setCartShopping(cartShoppingTemp);
    };
  const quantityProduct = (value: ProductCartInterface, quantityValue: number) => {
        let productTemp = value;
        const cartShoppingTemp = cartShopping.map(item => {
            if (item.id === productTemp?.id) {
                return {
                    ...item,
                    quantity: quantityValue,
                };
            } else {
                return item;
            }
        });
        setCartShopping(cartShoppingTemp);
      };
  
  const deletedProductFromCart = (value: ProductCartInterface) => {
    const cartShoppingTemp = cartShopping.filter(
        item => item.id !== value.id
    );
    setCartShopping(cartShoppingTemp);
  };

  const sendWhatsApp = (values: PersonalInfoInterface) => {
    
        const phoneToSend = "+5354321172"
            .replace(/[^\w\s]/gi, "")
            .replace(/ /g, "");
        let url = `https://api.whatsapp.com/send?phone=${phoneToSend}`;

        let total = 0;
        const listProducts = cartShopping
            .map(item => {
                let itemPrice = item.price;               

                total += itemPrice;
                return `(x${item.quantity}) ${item.name} - ${printPrice(
                    itemPrice
                )}`;
            })
            .join("\n");

        const payload = `Hola!, quería reservar un pedido.\n\nNombre: ${
            values.name
        }\nDescripción:${
            values.description
        }\n\n${listProducts}\n\nTotal:$${printPrice(
            subTotal
        )}\n\n**Gracias por elegirnos Grupo Aceña.**`;
        url += `&text=${encodeURI(payload)}`;

        window.open(url);
        setShowModalCheckoutForm(false);
    
  };
  
  const showProduct = (value: ProductCartInterface) => {
    setSeletedProduct(value);
    setShowModal(true);
};


  return (
    <div className="bg-white">
    {/* Hero section */}
    <div className="relative bg-slate-900">
        {/* Decorative image and overlay */}
        <div
            aria-hidden="true"
            className="absolute inset-0 overflow-hidden"
        >
            <img
                src={banner}
                alt=""
                className="h-full w-full object-cover object-center"
            />
        </div>
        <div
            aria-hidden="true"
            className="absolute inset-0 bg-slate-900 opacity-50"
        />

        {/* Navigation */}
        <div className="relative mx-auto flex max-w-3xl flex-col items-center py-32 px-6 text-center sm:py-64 lg:px-0">
            <h1 className="text-4xl uppercase font-bold tracking-tight text-white lg:text-6xl">
                Aceña-Venta Mayorista
            </h1>
            <p className="mt-4 text-xl text-white">
                "Nada como un buen PAN"
            </p>
        </div>
    </div>
    <section aria-labelledby=" sale-heading  col-start-1 col-end-3">
        <div className="overflow-hidden pt-32 grid gap-y-16 sm:-mt-60 ">
            <div className="bg-white">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div
                        className={`relative pt-48 sm:pt-48 pb-16 sm:pb-24`}
                    >
                        <div className=" sm:w-2/4 w-auto  ">
                           
                                <>
                                    <h2
                                        id="sale-heading"
                                        className="text-2xl font-bold tracking-tight text-slate-900 md:text-3xl"
                                    >
                                        ¿Quiénes somos?
                                    </h2>

                                    <p className="text-base mt-2 text-gray-900">
                                          La panadería Aceña combina la tradición y la modernidad para crear panes únicos con ingredientes frescos y técnicas innovadoras que evocan la autenticidad de un molino harinero de agua.
                                          Cabe destacar que la venta solo se realiza al por mayor con un minimo total de 100 unidades.
                                    </p>
                                </>
                           
                         
                                <div className="flex mt-5 flex-row items-center">
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className="h-4 w-4 mr-2 text-slate-500"
                                        aria-hidden="true"
                                    />
                                    <p className="text-base font-medium  text-gray-900">
                                       8:00 am - 11:00 am
                                    </p>
                                </div>
                          

                         
                             
                                    <div className="flex mt-2 flex-row items-center">
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            className="h-4 w-4 mr-2 text-slate-500"
                                            aria-hidden="true"
                                        />
                                        <p className="text-base font-medium  text-gray-900">
                                           +53 54321172
                                        </p>
                                    </div>
                            

                           
                                <div className="flex mt-2 flex-row items-center">
                                    <FontAwesomeIcon
                                        icon={faEnvelope}
                                        className="h-4 w-4 mr-2 text-slate-500"
                                        aria-hidden="true"
                                    />
                                    <p className="text-base font-medium  text-gray-900">
                                        {" "}
                                        atencionalcliente@grupoacena.com
                                    </p>
                                </div>
                          

                       
                                <div className="flex mt-2 flex-row items-center">
                                    <FontAwesomeIcon
                                        icon={faMapMarkerAlt}
                                        className="h-4 w-4 mr-2 text-slate-500"
                                        aria-hidden="true"
                                      />
                                       <p className="text-base font-medium  text-gray-900">
                                        {" "}
                                        Avenida Santa Catalina / Goicuria y Juan Delgado, 10 Octubre. La Hanana.
                                    </p>
                                   
                                </div>
                          

                           
                        </div>

                      
                            <div className="absolute mt-5 -top-32 left-1/2 -translate-x-1/2 transform sm:top-6 sm:translate-x-0">
                                <div className="ml-24 flex min-w-max space-x-6 sm:ml-3 lg:space-x-8">
                                    <div className="flex space-x-6 sm:flex-col sm:space-x-0 sm:space-y-6 lg:space-y-8">
                                        <div className="flex-shrink-0 bg-white rounded-lg">
                                            <img
                                                className="h-64 w-64 rounded-lg hover:opacity-60 object-cover md:h-72 md:w-72"
                                                src={
                                                  image1
                                                }
                                                alt=""
                                                // onClick={() => showGallery(0)}
                                            />
                                        </div>

                                        <div className=" mt-6 flex-shrink-0 sm:mt-0 bg-white rounded-lg">
                                            <img
                                                className="h-64 w-64 hover:opacity-60 rounded-lg object-cover md:h-72 md:w-72"
                                                src={
                                                  image2
                                                }
                                                alt=""
                                                // onClick={() => showGallery(1)}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex space-x-6 sm:-mt-20 sm:flex-col sm:space-x-0 sm:space-y-6 lg:space-y-8">
                                        <div className="flex-shrink-0 bg-white rounded-lg ">
                                            <img
                                                className="h-64  hover:opacity-60 w-64 rounded-lg object-cover md:h-72 md:w-72"
                                                src={
                                                image3
                                                }
                                                alt=""
                                                // onClick={() => showGallery(2)}
                                            />
                                        </div>

                                        <div className="mt-6 flex-shrink-0 sm:mt-0 bg-white rounded-lg">
                                            <img
                                                className="h-64 w-64 hover:opacity-60 rounded-lg object-cover md:h-72 md:w-72"
                                                src={
                                                 image4
                                                }
                                                alt=""
                                                // onClick={() => showGallery(3)}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex space-x-6  sm:flex-col sm:space-x-0 sm:space-y-6 lg:space-y-8">
                                        <div className="flex-shrink-0 bg-white rounded-lg">
                                            <img
                                                className="h-64 w-64 hover:opacity-60 rounded-lg object-cover md:h-72 md:w-72"
                                                src={
                                                  image5
                                                }
                                                alt=""
                                                // onClick={() => showGallery(4)}
                                            />
                                        </div>

                                        <div className="mt-6 flex-shrink-0 sm:mt-0 bg-white rounded-lg">
                                            <img
                                                className="h-64 w-64 hover:opacity-60 rounded-lg object-cover md:h-72 md:w-72"
                                                src={
                                                  image6
                                                }
                                                alt=""
                                                // onClick={() => showGallery(5)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                      
                    </div>
                </div>
            </div>
        </div>
    </section>

    <main>
        {/* Suggested product section */}
        {/* {suggestedProducts.length > 0 && (
            <section
                aria-labelledby="category-heading"
                className="pt-12 mb-5  sm:pt-16 xl:mx-auto  xl:max-w-full xl:px-8"
            >
                <div className="px-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 ">
                    <h2
                        id="category-heading"
                        className="text-2xl font-bold tracking-tight text-slate-900"
                    >
                        Para ti
                    </h2>
                </div>

                <div className="mt-4  ">
                    <div className="-my-2">
                        <div className="   sm:px-6 ">
                            <div className="relative flex items-center scrollbar-hide">
                                <FontAwesomeIcon
                                    icon={faChevronLeft}
                                    className="opacity-50 mx-2 cursor-pointer hover:opacity-100 "
                                    onClick={slideLeftSuggestedProducts}
                                    size={"2x"}
                                />

                                <div
                                    id="sliderSuggested"
                                    className="w-full  h-full  overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide mt-5  space-x-8 px-4 sm:px-6 lg:px-2 "
                                >
                                    {suggestedProducts.map(item => (
                                        <CardProduct
                                            product={item}
                                            onClick={() =>
                                                showProduct(item)
                                            }
                                            priceSystemId={1}
                                            cardWidth="w-52"
                                            addCart={addCart}
                                        />
                                    ))}
                                </div>

                                <FontAwesomeIcon
                                    icon={faChevronRight}
                                    className="opacity-50 mx-2 cursor-pointer hover:opacity-100"
                                    onClick={
                                        slideRightSuggestedProducts
                                    }
                                    size={"2x"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )} */}

        {/* onSale product section */}
        {/* {onSaleProduct.length > 0 && (
            <section
                aria-labelledby="category-heading"
                className="pt-12 pb-20  sm:pt-16  xl:mx-auto xl:max-w-full xl:px-8"
            >
                <div className="px-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 ">
                    <h2
                        id="category-heading"
                        className="text-2xl font-bold tracking-tight text-slate-900"
                    >
                        Ofertas
                    </h2>
                </div>

                <div className="mt-4  ">
                    <div className="-my-2">
                        <div className="   sm:px-6 ">
                            <div className="relative flex items-center scrollbar-hide">
                                <FontAwesomeIcon
                                    icon={faChevronLeft}
                                    className="opacity-50 mx-2 cursor-pointer hover:opacity-100 "
                                    onClick={slideLeftOfertedProducts}
                                    size={"2x"}
                                />

                                <div
                                    id="sliderOferted"
                                    className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide mt-5  space-x-8 px-4 sm:px-6 lg:px-2 "
                                >
                                    {onSaleProduct.map(item => (
                                        <>
                                            <CardProduct
                                                product={item}
                                                addCart={addCart}
                                                onClick={() =>
                                                    showProduct(item)
                                                }
                                                priceSystemId={1}
                                                cardWidth="w-52"
                                            />
                                        </>
                                    ))}
                                </div>

                                <FontAwesomeIcon
                                    icon={faChevronRight}
                                    className="opacity-50 mx-2 cursor-pointer hover:opacity-100"
                                    onClick={slideRightOfertedProducts}
                                    size={"2x"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )} */}

        {/* {saleCategorys.length > 0 && (
            <div className="sticky top-14 z-20 bg-white pb-5 ">
                <div className="  flex items-center scrollbar-hide">
                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        className="opacity-50 mx-2  cursor-pointer hover:opacity-100 "
                        onClick={slideLeft}
                        size={"2x"}
                    />

                    <div
                        id="slider"
                        className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide mt-5  space-x-8 px-4 sm:px-6 lg:px-2 "
                    >
                        {saleCategorys.map(item => (
                            <CardCategory category={item} />
                        ))}
                    </div>

                    <FontAwesomeIcon
                        icon={faChevronRight}
                        className="opacity-50 mx-2 cursor-pointer hover:opacity-100"
                        onClick={slideRight}
                        size={"2x"}
                    />
                </div>
            </div>
        )} */}

                                   
              <div className=" mx-auto max-w-2xl py-4 px-4 sm:py-6 sm:px-6 lg:max-w-7xl lg:px-8  ">
              <h2
                                        id="sale-heading"
                                        className="text-2xl mt-10 mb-5 font-bold tracking-tight text-slate-900 md:text-2xl"
                                    >
                                        Nuestros productos 
                                    </h2>
        <div className="grid grid-cols-2 gap-y-3 gap-x-3 sm:grid-cols-2 sm:gap-x-6 md:grid-cols-3 md:gap-y-6 md:gap-x-6   sm:gap-y-10 lg:grid-cols-4 lg:gap-y-6 lg:gap-x-6 xl:grid-cols-5 xl:gap-y-6 xl:gap-x-6">
          {PRODUCTS.map((product) => (
            <CardProduct
              product={product}
              onClick={() => showProduct(product)}
              priceSystemId={1}
              cardWidth={"w-full"}
              addCart={addCart}
            />
          ))}
        </div>
        </div>
    </main>

   

    {/* {showModalGallery && (
        <ModalGallery
            images={business?.images}
            onClick={() => setShowModalGallery(false)}
            index={indexGallery}
        />
    )} */}
    {showModal && (
        <ModalProduct
            product={seletedProduct}
            onClick={() => setShowModal(false)}
            addCart={addCart}
        />
    )}
    {showModalCheckoutForm && (
        <ModalCheckoutForm
            onClick={() => setShowModalCheckoutForm(false)}
            onSendWhatsApp={sendWhatsApp}
        />
    )}

    <header className="  fixed w-full z-30  top-0">
        {/* Secondary navigation */}
        <div
            className={`bg-slate-900  bg-opacity-60 backdrop-blur-md backdrop-filter`}
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div>
                    <div className="flex h-16 items-center justify-between">
                        {/* Logo (lg+) */}
                        <div className="hidden lg:flex lg:flex-1 lg:items-center">
                            <a href="/">
                                <img
                                    className="h-14 w-14 rounded-full"
                                    src={avartar}
                                    alt=""
                                />
                            </a>
                        </div>

                        {/* Logo (lg-) */}
                        <a href="/" className="lg:hidden">
                            <span className="sr-only uppercase">
                               Aceña
                            </span>
                            <img
                                src={
                                   avartar
                                }
                                alt=""
                                className="h-12 w-12 rounded-full"
                            />
                        </a>

                        <div className="flex flex-1 items-center justify-end">
                            <div className="flex items-center lg:ml-8">
                                <div className="ml-4 flow-root lg:ml-8">
                                    <button
                                        type="button"
                                        onClick={() => setOpen(true)}
                                        className="group -m-2 flex items-center p-2"
                                    >
                                        <FontAwesomeIcon
                                            icon={faShoppingBag}
                                            className="h-6 w-6 flex-shrink-0 text-white"
                                            aria-hidden="true"
                                        />

                                        <span className="ml-2 text-sm font-medium text-white">
                                            {cartShopping.length}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-30" onClose={setOpen}>
            <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
                                    <div className="flex-1 overflow-y-auto py-6 px-4 sm:px-6">
                                        <div className="flex items-start justify-between">
                                            <Dialog.Title className="text-lg font-medium text-gray-900">
                                                Bolsa de compra
                                            </Dialog.Title>
                                            <div className="ml-3 flex h-7 items-center">
                                                <button
                                                    type="button"
                                                    className="-m-2 p-2 text-gray-400 hover:text-gray-500"
                                                    onClick={() =>
                                                        setOpen(false)
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faTimes}
                                                        className="h-6 w-6"
                                                        aria-hidden="true"
                                                    />
                                                </button>
                                            </div>
                                        </div>

                                        <div className="mt-8">
                                            <div className="flow-root">
                                                <ul
                                                    role="list"
                                                    className="-my-4 divide-y divide-gray-200"
                                                >
                                                    {cartShopping.map(
                                                        product => (
                                                            <li
                                                                key={
                                                                    product.id
                                                                }
                                                                className="flex py-4"
                                                            >
                                                                <div className="h-16 w-16 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                                                    <img
                                                                        src={
                                                                            product.images
                                                                                ? product.images
                                                                                     
                                                                                : "http://apidev.tecopos.com/2022/11/5879bd4c-2ddc-434a-adca-d2a0c504825d.jpg"
                                                                        }
                                                                        alt={
                                                                            product.name
                                                                        }
                                                                        className="h-full w-full object-cover object-center"
                                                                    />
                                                                </div>

                                                                <div className="ml-4 flex flex-1 flex-col">
                                                                    <div>
                                                                        <div className="flex justify-between text-base font-medium text-gray-900">
                                                                            <div className="flex flex-row   w-32 overflow-hidden  ">
                                                                                <h3 className="">
                                                                                  
                                                                                    {
                                                                                        product.name
                                                                                    }
                                                                                </h3>
                                                                            </div>
                                                                            <div className="ml-4">
                                                                            
                                                                                <p                                                                                  
                                                                                >
                                                                                    {`${printPrice(
                                                                                        product
                                                                                            .price
                                                                                            
                                                                                    )}`} CUP
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex flex-1 mt-2 items-end justify-between text-sm">
                                                                        <div className="flex flex-row items-center">
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faMinusCircle
                                                                                }
                                                                                className="-ml-1 mx-2 text-gray-500 hover:text-rose-500"
                                                                                size="xl"
                                                                                aria-hidden="true"
                                                                                onClick={() =>
                                                                                    product.quantity !==
                                                                                    1
                                                                                        ? removeQuantityCart(
                                                                                              product
                                                                                          )
                                                                                        : deletedProductFromCart(
                                                                                              product
                                                                                          )
                                                                                }
                                                                            />
                  <input
                  type="number"
                  value={product.quantity}                 
                  onChange={(e) => quantityProduct(product, parseInt(e.target.value)) }                                                             
                  name=""
                  id=""
                  autoComplete="quantity"
                  className="block w-10  rounded-md border-0 p-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm "
                />
                                                                           
                                                                            {/* <p className="text-gray-500 font-medium">
                                                                                {
                                                                                    product.quantity
                                                                                }
                                                                            </p> */}
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faPlusCircle
                                                                                }
                                                                                className=" mx-2 text-gray-500 hover:text-orange-500"
                                                                                size="xl"
                                                                                aria-hidden="true"
                                                                                onClick={() =>
                                                                                    addProductCart(
                                                                                        product
                                                                                    )
                                                                                }
                                                                            />
                                                                        </div>

                                                                        <div className="flex">
                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    deletedProductFromCart(
                                                                                        product
                                                                                    )
                                                                                }
                                                                                className="font-medium text-gray-600 hover:text-rose-500"
                                                                            >
                                                                                <FontAwesomeIcon
                                                                                    icon={
                                                                                        faTrashAlt
                                                                                    }
                                                                                    className="-ml-1 mx-2"
                                                                                    size="lg"
                                                                                    aria-hidden="true"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                        <div className="flex justify-between text-base font-medium text-gray-900">
                                            <p>Subtotal</p>
                                            <p>
                                                ${subTotal.toFixed(2)}
                                            </p>
                                        </div>
                                        <p className="mt-8 text-base text-gray-400 md:order-1 md:mt-0">
                                            ¡Importante!. La cantidad total minima es de 100 unidades.
                                        </p>

                                        <div className="mt-6">
                                            <div
                                                onClick={() =>
                                                    setShowModalCheckoutForm(
                                                        true
                                                    )
                                                }
                                                className="flex items-center justify-center rounded-md border border-transparent bg-orange-500 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-orange-600"
                                            >
                                                Ordenar
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </div>
        </Dialog>
    </Transition.Root>
</div>
  )
}
